import sumBy from "lodash/sumBy";

/** Assuming evenly spaced percentile data, takes the average y value across the range. */
export const averageYValueInclusive = <Data extends object>(
  data: Data[],
  yKey: keyof Data & string,
  start: number,
  end: number,
) => {
  if (start > end) {
    return Number.NaN;
  }
  return sumBy(data.slice(start, end + 1), yKey) / (end - start + 1);
};

export const averageYValueInclusiveToString = <Data extends object>(
  data: Data[],
  yKey: keyof Data & string,
  start: number,
  end: number,
) => (averageYValueInclusive(data, yKey, start, end) * 100).toFixed(1) + "%";
